module.exports = __webpack_public_path__ + "img/apply-img-empty.9fbafc56.png";